import ProductTextLineBanner from './ProductTextLineBanner'

export default ProductTextLineBanner
